import { z } from "zod";

import { ExperienceProductDtoSchema } from "../../../dtos/experience-products";
import { castToNumber } from "../../../utils";

export const GetExperienceProductsRequestQueryParamSchema = z.object({
  limit: castToNumber.optional(),
  page: castToNumber.optional(),
});

export type GetExperienceProductsRequestQueryParamType = z.infer<
  typeof GetExperienceProductsRequestQueryParamSchema
>;

export const GetExperienceProductsRequestPathParamSchema = z.object({
  experienceId: z.string().uuid(),
});

export type GetExperienceProductsRequestPathParamType = z.infer<
  typeof GetExperienceProductsRequestPathParamSchema
>;

export const GetExperienceProductsResponseBodySchema = z.object({
  experienceProducts: ExperienceProductDtoSchema.array(),
  page: castToNumber.optional(),
});

export type GetExperienceProductsResponseBodyType = z.infer<
  typeof GetExperienceProductsResponseBodySchema
>;
